const messages = {
  step3: {
    actionBtn: "Se connecter",
  },
};

export default {
  messages,
};
